var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import ScrollableAnchor, { configureAnchors } from "react-scrollable-anchor";

configureAnchors({ offset: -60, scrollDuration: 400 });

import Header from "../../../components/Library/Header";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import Mission from "./Mission";
import Manifesto from "./Manifesto";
import Jobs from "./Jobs";
import Team from "./Team";

import styles from "./About.css";

var About = function (_Component) {
  _inherits(About, _Component);

  function About() {
    _classCallCheck(this, About);

    return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
  }

  _createClass(About, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.root },
        React.createElement(Header, {
          className: styles.aboutHeader,
          text: "About Axios" }),
        React.createElement(
          Layout,
          null,
          React.createElement(
            Sidebar,
            { className: styles.stickySidebar },
            React.createElement(
              "a",
              { className: styles.sidebarLinks, href: "#our-mission" },
              "Our Mission"
            ),
            React.createElement(
              "a",
              { className: styles.sidebarLinks, href: "#manifesto" },
              "Manifesto"
            ),
            React.createElement(
              "a",
              { className: styles.sidebarLinks, href: "#team" },
              "Team"
            ),
            React.createElement(
              "a",
              { className: styles.sidebarLinks, href: "#jobs" },
              "Jobs"
            )
          ),
          React.createElement(
            Content,
            null,
            React.createElement(
              ScrollableAnchor,
              { id: "our-mission" },
              React.createElement(Mission, null)
            ),
            React.createElement(
              ScrollableAnchor,
              { id: "manifesto" },
              React.createElement(Manifesto, null)
            ),
            React.createElement(
              ScrollableAnchor,
              { id: "team" },
              React.createElement(Team, null)
            ),
            React.createElement(
              ScrollableAnchor,
              { id: "jobs" },
              React.createElement(Jobs, null)
            )
          )
        )
      );
    }
  }]);

  return About;
}(Component);

export default About;


// WEBPACK FOOTER //
// ./src/about/components/About/About.js